import { render, staticRenderFns } from "./PaymentsInformation.vue?vue&type=template&id=a91b6f6a&scoped=true"
import script from "./PaymentsInformation.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentsInformation.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PaymentsInformation.vue?vue&type=style&index=0&id=a91b6f6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91b6f6a",
  null
  
)

export default component.exports